<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">No problem</h1>
			<p>Have a great day!</p>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './components/BaseNavLinks';

	export default {
		name: "NoProblem",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>